import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

import App from './App.vue'
import store from './store'

import { AxiosStatic } from "axios";

axios.defaults.baseURL = 'api';

Vue.use(VueAxios, axios)

Vue.config.productionTip = false

// Make the compiler happy
declare module 'vue/types/vue' {
  interface Vue {
    $http: AxiosStatic;
  }
}

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
